import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"],
    _excluded2 = ["className", "label", "description"];
import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './menu-item-sections.module.js';
/**
 * Container for side content of menu item.
 */

var MenuItemSideContent = function MenuItemSideContent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: clsx(styles.menuItemSideContent, _defineProperty({}, styles.textOnLightSecondary, typeof children === 'string'), className),
    children: children
  }));
};
/**
 * Text contents of an Item.
 */


var MenuItemMainContent = function MenuItemMainContent(_ref2) {
  var className = _ref2.className,
      label = _ref2.label,
      description = _ref2.description,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: clsx(styles.menuItemMainContent, className),
    children: [jsx("span", {
      className: clsx(styles.label, _defineProperty({}, styles.bold, Boolean(description))),
      children: label
    }), description ? jsx("span", {
      className: styles.description,
      children: description
    }) : null]
  }));
};

export { MenuItemMainContent, MenuItemSideContent };